(function () {
    'use strict';

    angular
        .module('app.shared')
        .component('sc3Timespan', {
            templateUrl: 'app/shared/generic/timespan.component.html',
            controller: TimespanComponent,
            require: { ngModel: 'ngModel' }
        });

    var isNumber = angular.isNumber,
        isObject = angular.isObject,
        isUndefined = angular.isUndefined,
        isDefined = angular.isDefined,
        guid = angular.guid;

    TimespanComponent.$inject = ['$element', '$scope', '$attrs'];
    function TimespanComponent($element, $scope, $attrs) {
        // Variables
        var ctrl = this,
            conversion = { days: 86400000, hours: 3600000, minutes: 60000, seconds: 1000, milliseconds: 1 },
            nullValue = { days: null, hours: null, minutes: null, seconds: null, milliseconds: null },
            ngModel;

        // Properties
        ctrl.ngModel = null;

        // Methods
        ctrl.$onInit = init;
        ctrl.change = change;

        //////////////////////////////////////////////////////

        // Init
        function init() {
            initElement();
            initModel();
            initValidation();
        }
        function initElement() {
            $element.on('keypress', keypress);
            $element.on('focusout', focusout);
        }
        function initModel() {
            ngModel = ctrl.ngModel;
            ngModel.$parsers.push(parser);
            ngModel.$formatters.push(formatter);
            ngModel.$render = render;
        }
        function initValidation() {
            var minVal, maxVal;

            if (isDefined($attrs.min) || $attrs.ngMin) {
                ngModel.$validators.min = validateMin;
                $attrs.$observe('min', minWatch);
            }
            if (isDefined($attrs.max) || $attrs.ngMax) {
                ngModel.$validators.max = validateMax;
                $attrs.$observe('max', maxWatch);
            }

            ////////////////////

            function validateMin(value) {
                return ngModel.$isEmpty(value) || isUndefined(minVal) || value >= minVal;
            };
            function validateMax(value) {
                return ngModel.$isEmpty(value) || isUndefined(maxVal) || value <= maxVal;
            }
            function minWatch(val) {
                minVal = parseNumberAttrVal(val);
                ngModel.$validate();
            }
            function maxWatch(val) {
                maxVal = parseNumberAttrVal(val);
                ngModel.$validate();
            }
            function parseNumberAttrVal(val) {
                if (isDefined(val) && !isNumber(val))
                    val = parseFloat(val);
                return !isNaN(val) ? val : undefined;
            }
        }

        // Events
        function change() {
            var value = { days: ctrl.days, hours: ctrl.hours, minutes: ctrl.minutes, seconds: ctrl.seconds, milliseconds: ctrl.milliseconds };
            if (Object.values(value).every(ngModel.$isEmpty))
                value = null;
            ngModel.$setViewValue(value);
        }
        function keypress(e) {
            if (e.which < 48 || e.which > 57) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
        function focusout(e) {
            $element.triggerHandler('blur'); // set $touched
        }

        // NgModel
        function parser(value) {
            return ngModel.$isEmpty(value) ? null :
                isObject(value) ? Object.entries(value).reduce(reduce, null) :
                undefined;

            function reduce(acc, cur, index) {
                return !ngModel.$isEmpty(cur[1]) ? acc + cur[1] * conversion[cur[0]] : acc;
            }
        }
        function formatter(value) {
            if (!ngModel.$isEmpty(value)) {
                if (!isNumber(value)) 
                    throw new Error('Expected value to be a number!')
                return Object.entries(conversion).reduce(reduce, {});
            }
            return value;

            function reduce(acc, cur, index) {
                var quotient = acc[cur[0]] = Math.trunc(value / cur[1]) || null;
                value -= quotient * cur[1];
                return acc;
            }
        }
        function render() {
            Object.entries(ngModel.$viewValue || nullValue).forEach(setValue);

            function setValue(entry) {
                ctrl[entry[0]] = entry[1];
            }
        }
    }
})();
